import React, { Component } from "react";
import actions from '../actions';
import authActions from '../../auth/actions';
import { connect } from 'react-redux';
import _ from '../../shared/utils/ObjectUtils';
import DashboardPage from "../components/DashboardPage";
import { I18n } from "react-redux-i18n";
import WidgetUtils from "../utils/WidgetUtils";
import Utils from "../components/widgets/Utils";
import DashboardUtils from "../utils/DashboardUtils";
import { config } from "../../config";
import interfacesActions from "../../interfaces/actions";
import Cookies from 'js-cookie'
import axios from 'axios'

class DashboardPageContainer extends Component {
    constructor() {
        super();
        this.state = {
            isDashboardFullScreen: false,
            onEditMode: false,
            dashboard: null,
            alert: {
                show: false
            },
            entitiesTree: {},
            modalData: {},
            modalIsOpen: false,
            widgetId: null,
            widgetType: null,
        };
        this.readingsPollingTask = null;
    }


    getCookie = async () => {

        const response = await axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-cookie")
        return response.data
    }


    componentDidMount() {
        const { dashboard } = this.props;

        if (!_.isNil(dashboard)) {
            this.init()
        }
    }

    componentWillUnmount() {
        this.stopLastReadingsPolling()
    }

    onDashboardEditClicked = () => {
        const { onEditMode } = this.state;

        this.setState({
            onEditMode: !onEditMode
        }, () => {
            if (!onEditMode) {
                this.stopLastReadingsPolling()
            } else {
                this.startLastReadingsPolling()
            }
        });
    };

    onFullScreenClicked = () => {
        const { isDashboardFullScreen } = this.state;

        this.setState({
            isDashboardFullScreen: !isDashboardFullScreen
        })
    };

    onCreateWidgetClicked = () => {
        this.setState({
            modalIsOpen: true
        })
    };

    hideModal = () => {
        this.setState({
            modalIsOpen: false,
            widgetToEdit: null,
        })
    };

    init() {
        const { getDashboardInfo } = this.props;

        getDashboardInfo();
        this.startLastReadingsPolling();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.loadingWidgetCreateRequest && !this.props.loadingWidgetCreateRequest) {
            if (this.props.widgetWasCreated) {
                this.handleWidgetCreateSuccess()
            } else {
                this.handleWidgetCreateError(this.props.error)
            }
        } else if (prevProps.loadingWidgetEditRequest && !this.props.loadingWidgetEditRequest) {
            if (this.props.widgetWasEdited) {
                this.handleWidgetEditSuccess()
            } else {
                this.handleWidgetEditError(this.props.error)
            }
        } else if (prevProps.loadingWidgetDuplicateRequest && !this.props.loadingWidgetDuplicateRequest) {
            if (this.props.widgetWasDuplicated) {
                this.handleWidgetDuplicateSuccess()
            } else {
                this.handleWidgetDuplicateError(this.props.error)
            }
        } else if (prevProps.loadingDashboardEntitiesTreeRequest && !this.props.loadingDashboardEntitiesTreeRequest) {
            if (!_.isEmpty(this.props.entitiesTree)) {
                this.handleLoadEntitiesTreeSuccess(this.props.entitiesTree)
            } else {
                this.handleLoadEntitiesTreeError(this.props.error)
            }
        } else if (prevProps.loadingWidgetDeleteRequest && !this.props.loadingWidgetDeleteRequest) {
            if (this.props.widgetWasDeleted) {
                this.handleWidgetDeleteSuccess()
            } else {
                this.handleWidgetDeleteError(this.props.error)
            }
        } else {
            if (prevProps.loading && !this.props.loading) {
                this.fetchWidgetConfigsAndUpdateRealTimeInterfaces(this.props.widgetsConfigs);
            }
        }
    }

    startLastReadingsPolling() {
        if (!_.isNil(this.readingsPollingTask)) {
            return;
        }
        this.readingsPollingTask = setInterval(() => {
            this.getRealTimeWidgetsReadings();
        }, config.homepage.refreshWidgetDataIntervalMillis);
    }

    stopLastReadingsPolling() {
        if (this.readingsPollingTask) {
            clearInterval(this.readingsPollingTask);
            this.readingsPollingTask = null;
        }
    }

    onLayoutChange = (newLayout) => {
        const {
            updateLayoutAndWidgetsPosition,
            widgetsConfigs,
            layout,
            dashboard: {
                id: dashboardId
            }
        } = this.props;
        const { onEditMode } = this.state;

        if (!onEditMode || _.isNil(newLayout) || _.isEmpty(newLayout) || DashboardUtils.layoutIsTheSameAsBefore(layout, newLayout)) {
            return;
        }

        let widgetsWithNewLayout = newLayout.filter(widgetLayout => {
            return !(_.isNil(widgetsConfigs[widgetLayout.i]) || DashboardUtils.widgetIsTheSameAsBefore(widgetsConfigs[widgetLayout.i], widgetLayout));
        });

        let widgetsDeleted = [];
        let widgetsCreated = [];

        if (layout.length !== newLayout.length) {
            widgetsDeleted = _.differenceBy(layout, newLayout, 'i');
            widgetsCreated = _.differenceBy(newLayout, layout, 'i');
        }

        updateLayoutAndWidgetsPosition(widgetsWithNewLayout, widgetsCreated, widgetsDeleted, dashboardId);
    };

    getWidgetsProps = widget => {
        const {
            widgetsData,
            interfacesDetails,
            dashboard,
        } = this.props;
        const { onEditMode } = this.state;

        const widgetData = this.getWidgetDataFromState(widget, widgetsData);
        const interfaceDetails = this.getInterfaceDetailsFromState(widget, interfacesDetails);

        return {
            ...widgetData,
            ...widget,
            interfaceDetails: interfaceDetails,
            onError: _.has(widget.configs, 'widgetError') || (!_.isNil(widgetData) && !_.isNil(widgetData.data) ? widgetData.data.error : false),
            isEditMode: onEditMode,

            onEditClick: () => this.onEditClick(dashboard.id, widget),
            onForceUpdateClick: () => this.onForceUpdateClick(widget),
            onDeleteClicked: () => this.handleDeleteClick(dashboard.id, widget),
            onWidgetDidMount: () => this.onWidgetDidMount(widgetsData, onEditMode, widget),
            onDuplicateClicked: () => this.onDuplicateClicked(dashboard.id, widget),
        };
    };

    onWidgetDidMount = (widgetsData, onEditMode, widget) => {
        this.fetchWidgetsConfigs(widgetsData, onEditMode, [widget]);
    };

    onEditClick = (dashboardId, widget) => {
        this.setState({
            modalIsOpen: true,
            widgetToEdit: widget,
        })
    };

    onForceUpdateClick = (widget) => {
        let hasError = _.has(widget.configs, 'widgetError');
        if (hasError) {
            return;
        }
        switch (widget.type) {
            case WidgetUtils.WidgetType.CONTROLLER:
            case WidgetUtils.WidgetType.DIRECT_VALUE:
                this.getRealTimeWidgetsReadings();
                break;
            case WidgetUtils.WidgetType.COMPLEX_CHART:
                this.props.loadChartData(widget.id, null);
                break;
            default:
                break;
        }
    };

    onDuplicateClicked(dashboardId, widget) {
        const { widgetsConfigs, duplicateWidget } = this.props;

        if (widgetsConfigs.length >= config.widgets.max) {
            this.setState({
                alert: {
                    show: true,
                    type: 'error',
                    title: I18n.t('dashboard.alerts.widget.widgetsMax.title'),
                    html: I18n.t('dashboard.alerts.widget.widgetsMax.error'),
                    confirmButtonText: I18n.t('forms.ok'),
                    onConfirm: this.hideAlert
                }
            })
        }
        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('dashboard.alerts.widget.duplicate.title'),
                html: I18n.t('dashboard.alerts.widget.duplicate.text'),
                confirmButtonText: I18n.t('forms.duplicate'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    duplicateWidget(widget.id);
                }
            }
        });
    }

    handleWidgetCreateSuccess = () => {
        this.fetchWidgetConfigsAndUpdateRealTimeInterfaces();

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('dashboard.alerts.widget.create.success.title'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleWidgetCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('dashboard.alerts.widget.create.error.title'),
                html: I18n.t('dashboard.alerts.widget.create.error.error'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleWidgetEditSuccess = () => {
        this.fetchWidgetConfigsAndUpdateRealTimeInterfaces();

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('dashboard.alerts.widget.edit.success.title'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };
    handleWidgetEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('dashboard.alerts.widget.edit.error.title'),
                html: I18n.t('dashboard.alerts.widget.edit.error.error'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleWidgetDuplicateSuccess = () => {
        this.fetchWidgetConfigsAndUpdateRealTimeInterfaces();

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('dashboard.alerts.widget.duplicate.success.title'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };
    handleWidgetDuplicateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('dashboard.alerts.widget.duplicate.error.title'),
                html: I18n.t('dashboard.alerts.widget.duplicate.error.error'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleDeleteClick = (dashboardId, widget) => {
        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('dashboard.alerts.widget.delete.title'),
                html: I18n.t('dashboard.alerts.widget.delete.text'),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    this.deleteWidgetFromDashboard(widget);
                }
            }
        });
    };

    handleWidgetDeleteSuccess = () => {

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('dashboard.alerts.widget.delete.success.title'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleWidgetDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('dashboard.alerts.widget.delete.error.title'),
                html: I18n.t('dashboard.alerts.widget.delete.error.error'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    fetchWidgetsConfigs = (widgetsData, onEditMode, widgets) => {
        if (onEditMode) {
            return;
        }

        widgets.forEach(widget => {
            let hasError = _.has(widget.configs, 'widgetError');

            if (hasError || !_.isNil(widgetsData[widget.id])) {
                return;
            }
            switch (widget.type) {
                case WidgetUtils.WidgetType.COMPLEX_CHART:
                    this.props.loadChartData(widget.id, null);
                    break;
                default: break;
            }
        });
    };

    getWidgetDataFromState = (widget, widgetsData) => {

        if (_.isNil(widgetsData)) {
            return {};
        }
        switch (widget.type) {
            case WidgetUtils.WidgetType.CONTROLLER:
            case WidgetUtils.WidgetType.DIRECT_VALUE:
                if (_.isNil(widgetsData.realTimeInterfacesData[widget.configs.interfaceIds])) {
                    return {};
                }
                return widgetsData.realTimeInterfacesData[widget.configs.interfaceIds];

            default:
                return {
                    data: widgetsData[widget.id]
                };
        }
    };

    deleteWidgetFromDashboard = (deletedWidget) => {
        const { deleteWidget, widgetsConfigs } = this.props;

        this.hideAlert();

        deleteWidget(deletedWidget);
        this.updateRealTimeInterfaces(widgetsConfigs);
    };

    getInterfaceDetailsFromState = (widget, interfaceDetails = {}) => {

        switch (widget.type) {
            case WidgetUtils.WidgetType.CONTROLLER:
            case WidgetUtils.WidgetType.DIRECT_VALUE:
                return interfaceDetails[widget.configs.interfaceIds];
            default:
                return null
        }
    };

    getRealTimeWidgetsReadings = () => {
        const { realTimeInterfaces, updateRealTimeWidgetsData } = this.props;

        if (!_.isNil(realTimeInterfaces)) {
            updateRealTimeWidgetsData(realTimeInterfaces);
        }
    };

    fetchWidgetConfigsAndUpdateRealTimeInterfaces = (widgetsConfigsFromProps) => {
        const { widgetsConfigs } = this.props;

        let widgetsConfigsForUpdate = widgetsConfigsFromProps ? widgetsConfigsFromProps : widgetsConfigs;
        this.updateRealTimeInterfaces(widgetsConfigsForUpdate);
        this.updateInterfacesDetails(widgetsConfigsForUpdate);
    };

    updateRealTimeInterfaces = (widgetsConfigs) => {
        const { updateRealTimeWidgetsData } = this.props;

        const realTimeInterfaces = Utils.getRealTimeInterfaces(widgetsConfigs);

        if (!_.isEmpty(realTimeInterfaces)) {
            updateRealTimeWidgetsData(realTimeInterfaces);
        }
    };

    updateInterfacesDetails = (widgetsConfigs) => {
        const { interfacesDetails, loadWidgetInterfaces } = this.props;

        let interfacesIds = Utils.getInterfacesIds(widgetsConfigs);

        if (!_.isEmpty(interfacesDetails) && interfacesDetails) {
            interfacesIds = interfacesIds.filter(interfaceId => Object.keys(interfacesDetails).includes(interfaceId));
        }
        if (_.isEmpty(interfacesIds)) {
            return;
        }
        loadWidgetInterfaces(interfacesIds);
    };

    loadEntitiesTree = (filter, state, inputFilter) => {
        const { getDashboardEntitiesTree, } = this.props;

        const user = this.getCookie();
        getDashboardEntitiesTree(user.entity.id);
    };

    handleLoadEntitiesTreeSuccess = (entitiesTree) => {
        this.setState({
            entitiesTree: entitiesTree
        })
    };
    handleLoadEntitiesTreeError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('dashboard.alerts.entitiesTree.load.error.title'),
                html: I18n.t('dashboard.alerts.entitiesTree.load.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const { alert, onEditMode, entitiesTree, modalIsOpen, modalData, widgetToEdit } = this.state;

        const {
            loading,
            error,
            layout,
            widgetsConfigs,
            dashboard,
            loadingWidgetDuplicateRequest,
            loadingDashboardEntitiesTreeRequest,
            loadingWidgetDeleteRequest,
            isDashboardFullScreen,
        } = this.props;

        const widgetsConfigsWithInterfaces = {};

        Object.keys(widgetsConfigs).forEach(widgetId => {
            widgetsConfigsWithInterfaces[widgetId] = this.getWidgetsProps(widgetsConfigs[widgetId])
        });

        return (
            <DashboardPage
                alert={{
                    ...alert,
                    loading: loadingWidgetDuplicateRequest || loadingDashboardEntitiesTreeRequest || loadingWidgetDeleteRequest
                }}
                error={error}
                layout={layout}
                widgetsConfigs={widgetsConfigsWithInterfaces}

                dashboard={dashboard}

                loading={loading}
                onEditMode={onEditMode}
                isDashboardFullScreen={isDashboardFullScreen}
                modalIsOpen={modalIsOpen}
                modalData={modalData}
                widgetToEdit={widgetToEdit}

                onLayoutChange={this.onLayoutChange}
                onClick={this.onDashboardEditClicked}
                onFullScreenClicked={this.onFullScreenClicked}
                onCreateWidgetClicked={this.onCreateWidgetClicked}
                hideModal={this.hideModal}

                loadEntitiesTree={this.loadEntitiesTree}
                entitiesTree={entitiesTree}
            />
        );
    }
}

const mapStateToProps = ({ dashboardAndWidgetsReducer, interfacesReducer }) => {
    const { dashboardReducer } = dashboardAndWidgetsReducer;
    return {
        loading: dashboardReducer.loading,
        error: dashboardReducer.error,
        layout: dashboardReducer.layout,
        dashboard: dashboardReducer.dashboard,
        widgetsConfigs: dashboardReducer.widgets,
        realTimeInterfaces: dashboardReducer.realTimeInterfaces,

        widgetsData: {
            ...dashboardReducer.widgetsData,
            realTimeInterfacesData: dashboardReducer.realTimeInterfacesData
        },

        loadingWidgetDuplicateRequest: dashboardReducer.loadingWidgetDuplicateRequest,
        widgetWasDuplicated: dashboardReducer.widgetWasDuplicated,

        loadingWidgetDeleteRequest: dashboardReducer.loadingWidgetDeleteRequest,
        widgetWasDeleted: dashboardReducer.widgetWasDeleted,

        loadingDashboardEntitiesTreeRequest: dashboardReducer.loadingDashboardEntitiesTreeRequest,
        entitiesTree: dashboardReducer.entitiesTree,

        interfacesDetails: interfacesReducer.interfacesDetails,

        widgetWasCreated: dashboardReducer.widgetWasCreated,
        loadingWidgetCreateRequest: dashboardReducer.loadingWidgetCreateRequest,

        widgetWasEdited: dashboardReducer.widgetWasEdited,
        loadingWidgetEditRequest: dashboardReducer.loadingWidgetEditRequest,
    };
};

const mapDispatchToProps = {
    getDashboardInfo: actions.getDashboardInfo,
    newDashboard: actions.newDashboard,
    updateLayoutAndWidgetsPosition: actions.updateLayoutAndWidgetsPosition,
    updateRealTimeWidgetsData: actions.updateRealTimeWidgetsData,
    loadWidgetInterfaces: interfacesActions.loadInterfacesDetails,
    deleteWidget: actions.deleteWidget,
    duplicateWidget: actions.duplicateWidget,
    getDashboardEntitiesTree: actions.getDashboardEntitiesTree,
    loadChartData: actions.loadChartData
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DashboardPageContainer);
